












































































































































import { changeLoading } from '@/util/plugins';
import { Component, Vue } from 'vue-property-decorator';
import { component } from 'vue/types/umd';
const dateFormat = require('bmh/date-format');
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  sort: `${FCAPI}/shang/ruan/realcase/sort`,
  is_shelf: `${FCAPI}/shang/ruan/realcase/status`,
  get_list: `${FCAPI}/shang/ruan/realcase`,
  get_style_list: `${FCAPI}/shang/ruan/style`,
  get_cummunity_list: `${FCAPI}/shang/ruan/community/name`,
  edit_sample: `${FCAPI}/shang/ruan/sample`,
};
function initStyleList(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
const status = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '上架中',
  },
  {
    value: 2,
    label: '已下架',
  },
];

interface Table<T> {
  limit: number;
  total: number;
  detail: T[];
  current: number;
  last: number;
}
function initDesignWorksList(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
function initForm() {
  return {
    name: '',
    community_id: 0,
    style_id: 0,
    status: 0,
    recommend_type: 0,
  };
}
function getData(remote?: Table<any>) {
  remote = (remote || {}) as Table<any>;
  return {
    limit: remote.limit || 20,
    current: remote.current || 1,
    detail: remote.detail || [],
    total: remote.total || 0,
    last: remote.last || 0,
  };
}
@Component
export default class RealSence extends Vue {
  is_loading = false;
  visible = false;
  table_data: Table<any> = getData();
  style_list: any = initDesignWorksList();
  form: any = initForm();
  popup_id: number = 0;
  sort = 0;
  community_data: any = [];
  get status() {
    return status;
  }
  async Shelf(record: any, index: number) {
    const send_data = {
      status: index === 0 ? 2 : 1,
    };
    const res: any = await this.$axios.put(`${API.is_shelf}/${record.id}`, send_data);
    if (res.data.status === 200) {
      this.$message.success('操作成功');
      this.search(this.table_data.current);
    } else {
      this.$message.error(res.data.message);
    }
  }
  show_sort_change(record: any) {
    this.sort = record.sort;
    this.popup_id = record.id;
  }
  cancel() {
    this.popup_id = 0;
  }
  async changeSort(record: any) {
    if (this.sort % 1 !== 0 || this.sort <= 0) {
      this.$message.error('排序值须为正整数');
      return;
    }
    const res: any = await this.$axios.put(`${API.sort}/${record.id}`, {
      sort: this.sort,
    });
    if (res.data.status === 200) {
      this.$message.success('编辑成功');
      this.search(this.table_data.current);
      this.popup_id = 0;
    }
  }
  add() {
    this.$router.push('/operation/add-sence-example');
  }
  isShowSort(record: any) {
    return record.id === this.popup_id;
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  clearForm() {
    this.form = initForm();
  }
  @changeLoading(['is_loading'])
  async getStyleList(
    query_params: any = {
      current: 1,
    }
  ) {
    const url = getUrl(API.get_style_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.style_list = initDesignWorksList(res.data.data);
    this.style_list.detail.unshift({
      id: 0,
      name: '全部',
    });
  }
  listBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }
  changePage(page: any) {
    this.search(page.current);
  }
  paginationOption(data: any) {
    return {
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 0,
      total: data.total || 0,
      current: data.current || 0,
    };
  }
  @changeLoading(['is_loading'])
  async search(page: number = 1) {
    const send_data = {
      name: this.form.name ? this.form.name : '',
      community_id: this.form.community_id ? this.form.community_id : '',
      status: this.form.status ? this.form.status : '',
      style_id: this.form.style_id ? this.form.style_id : '',
      current: page,
      limit: 20,
      recommend_type_set: this.form.recommend_type,
    };
    const url = getUrl(API.get_list, send_data);
    const res = await this.$axios.get(url);
    if (res.data.status === 200) {
      this.table_data = getData(res.data.data);
    }
  }
  @changeLoading(['is_loading'])
  async getCommunityList() {
    const res = await this.$axios.get(API.get_cummunity_list);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.community_data = res.data.data;
  }
  created() {
    this.getStyleList();
    this.getCommunityList();
    this.search(1);
  }
}
